import React from 'react';

interface Props {
  name: string;
  // Add additional styling classes using className prop
  className?: string;
}
const Button: React.FC<Props> = ({ name, className }) => {
  const buttonClass =
    'flex w-full justify-center rounded-sm bg-primary px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary';
  return (
    <button type="submit" className={`${buttonClass} ${className ?? ''}`}>
      {name}
    </button>
  );
};

export default Button;
